var map = {
	"./arrow-back.svg": "84e0",
	"./arrow.svg": "5975",
	"./attendance.svg": "369e",
	"./career_counseling.svg": "2c1a",
	"./close-eye.svg": "bc7b",
	"./community_development.svg": "b0ed",
	"./copy-icon.svg": "2d02",
	"./document-icon.svg": "0b8b",
	"./done_attendance.svg": "15c8",
	"./hyperlink-icon.svg": "0e40",
	"./loyalty_program.svg": "8846",
	"./need_attendance.svg": "a686",
	"./not_attendance.svg": "719a",
	"./open-eye.svg": "49a3",
	"./pencil-white.svg": "20b3",
	"./pencil.svg": "7576",
	"./portfolio_building.svg": "16c5",
	"./pricing.svg": "3532",
	"./pricing2.svg": "9533",
	"./soft_skill_coaching.svg": "82f9",
	"./step_1.svg": "4140",
	"./step_2.svg": "7a21",
	"./step_3.svg": "9729",
	"./step_4.svg": "ca00",
	"./submission-icon.svg": "231f",
	"./time-outline.svg": "6779"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";